import { render, staticRenderFns } from "./CDN.vue?vue&type=template&id=62d4653f&scoped=true&"
import script from "./CDN.vue?vue&type=script&lang=js&"
export * from "./CDN.vue?vue&type=script&lang=js&"
import style0 from "./CDN.vue?vue&type=style&index=0&id=62d4653f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4653f",
  null
  
)

component.options.__file = "CDN.vue"
export default component.exports